import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgKojicAcidGlyphSecondary from './svgs/KojicAcidGlyphSecondary.js';
import SvgKojicAcidGlyph from './svgs/KojicAcidGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var kojicAcidGlyph = (props => useIcon(SvgKojicAcidGlyph, SvgKojicAcidGlyphSecondary, props));

export { kojicAcidGlyph as default };
